import { useEffect } from 'react';

import { useAppSelector } from '../../app/hooks';
import { getUtmSource } from '../../lib/utmManager';
import { sanitize, validateUrlOrReturnEmpty } from '../../utils/functionUtils';
import { merchantInfoByProductUUID } from '../../utils/productUUIDConstants';
import { SESSION_STORAGE } from '../../utils/sessionStorageConstants';

interface DynamicQRCodeProps {
  height: string;
  width: string;
  image: string;
}

export default function DynamicQRCode({
  height,
  width,
  image,
}: DynamicQRCodeProps) {
  const productUUID = useAppSelector(
    (state) => state.merchantDataSelector.productUUID
  );

  const qrInfo = merchantInfoByProductUUID[productUUID].qrInfo;

  const utmSource = getUtmSource(productUUID);
  const offerConfigUUIDs = sessionStorage.getItem(
    SESSION_STORAGE.OFFER_CONFIG_UUIDS
  )!;
  const prm = sessionStorage.getItem(SESSION_STORAGE.PRM)!;

  useEffect(() => {
    const divWrapper = document.getElementById('qr-code-1');
    const sanitizedProductUUID = sanitize(productUUID || '');
    const sanitizedLpName = sanitize(qrInfo?.lpName || '');
    const sanitizedIosLink = validateUrlOrReturnEmpty(qrInfo?.iosLink || '');
    const sanitizedAndroidLink = validateUrlOrReturnEmpty(
      qrInfo?.androidLink || ''
    );
    const sanitizedUtmSource = sanitize(utmSource || '');
    const sanitizedOfferConfigUUIDs = sanitize(offerConfigUUIDs || '');
    const sanitizedPrm = sanitize(prm || '');

    if (image != '' && productUUID != null && divWrapper) {
      // add script link
      const scriptHeader = document.createElement('script');
      scriptHeader.setAttribute('type', 'text/javascript');
      scriptHeader.src = 'https://app.stg.imprint.co/qr-code/dynamic-qrcode.js';
      document.head.append(scriptHeader);

      // add script call on load
      scriptHeader.onload = function () {
        const scriptExec = document.createElement('script');
        scriptExec.setAttribute('type', 'text/javascript');
        scriptExec.innerHTML = `window.dynamicQrcode.generateDeeplink("${sanitizedProductUUID}", "#qr-code-1", "","${sanitizedLpName}","${sanitizedIosLink}","${sanitizedAndroidLink}", "${sanitizedUtmSource}", ${height}, ${width}, "", "${sanitizedOfferConfigUUIDs}", "${sanitizedPrm}");`;
        divWrapper.appendChild(scriptExec);
      };

      // add default image only once
      const img = document.getElementById('qr-code-img');
      if (img) {
        img.setAttribute('src', image);
        img.setAttribute('height', height);
        img.setAttribute('width', width);
        img.setAttribute('id', 'qr-code-img');
      } else {
        const img = document.createElement('img');
        img.setAttribute('src', image);
        img.setAttribute('height', height);
        img.setAttribute('width', width);
        img.setAttribute('id', 'qr-code-img');
        divWrapper?.appendChild(img);
      }

      return () => {
        scriptHeader.remove();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image, productUUID, qrInfo]);

  return <div id="qr-code-1"></div>;
}
